export default __webpack_public_path__ + "static/media/TARA BODY.032ca484.png";